import React, { useCallback, useEffect, useState } from "react";
import { Edit, Delete } from "@mui/icons-material";
import { useAppDispatch, useAppSelector } from "store/hooks";

import {
  handleDeleteBrandRequest,
  handleGetCatalogBrandsRequest,
} from "store/modules/Catalog/thunk.store";
import { CoverageCatalogBrandsResponse } from "store/modules/Catalog/types.store";
import { useTranslation } from "react-i18next";
import * as Styled from "./styles";
import UpdateCatalogModal from "./components/UpdateCatalogModal";

interface Data {
  type: any;
  action: any;
}

interface HeadCell {
  disablePadding: boolean;
  id: keyof Data;
  label: string;
  numeric: boolean;
}
export const useBrands = () => {
  const dispatch = useAppDispatch();

  const { t } = useTranslation();
  const [brands, setBrands] = useState<CoverageCatalogBrandsResponse | null>();
  const [edit, setEdit] = useState<boolean>(false);
  const [selected, setSelected] = useState(null);

  const { catalogBrands } = useAppSelector((state) => state.catalog);

  const HandleCatalogProducts = useCallback(() => {
    setBrands(catalogBrands);
  }, [catalogBrands]);

  useEffect(() => {
    if (!catalogBrands?.data) {
      dispatch(handleGetCatalogBrandsRequest());
    }
    if (catalogBrands?.data) {
      HandleCatalogProducts();
    }
  }, [dispatch, HandleCatalogProducts, catalogBrands]);

  const handleDeleteBrand = useCallback(
    async (brandId: string) => {
      await dispatch(handleDeleteBrandRequest({ brandId }));
    },
    [dispatch],
  );

  const headCellsBrands: readonly HeadCell[] = [
    {
      id: "type",
      numeric: false,
      disablePadding: true,
      label: t("brand"),
    },
    {
      id: "action",
      numeric: true,
      disablePadding: false,
      label: "",
    },
  ];

  function createData(type: any, action: any): Data {
    return {
      type,
      action,
    };
  }

  const ActionEditBrandModal = () => {
    return (
      <UpdateCatalogModal
        isOpen={edit}
        update={selected}
        title={t("brand")}
        onClose={() => setEdit(false)}
      />
    );
  };

  const ActionButton = (data: any, isEdit: any) => {
    if (isEdit?.length) {
      return (
        <div style={{ width: "200px", display: "flex" }}>
          <Styled.ActionContainer
            onClick={() => handleDeleteBrand(data.data.id)}
            color="primary"
            variant="text"
            endIcon={<Delete />}
          >
            {t("delete").toUpperCase()}
          </Styled.ActionContainer>
          <Styled.ActionContainer
            onClick={() => {
              setSelected(data);
              setEdit(true);
            }}
            color="secondary"
            variant="text"
            endIcon={<Edit />}
          >
            {t("edit").toUpperCase()}
          </Styled.ActionContainer>
        </div>
      );
    }
    return <div style={{ width: "200px", display: "flex" }}> </div>;
  };

  const rowsBrands =
    brands?.data.map((data) => {
      return createData(data.name, <ActionButton data={data} />);
    }) || [];

  return { headCellsBrands, rowsBrands, ActionEditBrandModal };
};
